export default {
  methods: {
    getJobActionFormId (standClass) {
      let classStandObject = this.$store.state.standClass
      let standClassId = classStandObject[standClass]
      return standClassId || null
    },
    endJobActions () {
      let activeStand = this.activeStand
      if (activeStand) {
        this.$store.commit('endJobActions', activeStand)
        if (this.getJobActionFormId(activeStand.class) === 1 || this.getJobActionFormId(activeStand.class) === 4 || this.getJobActionFormId(activeStand.class) === 6) {
          if (confirm('Any pirates?')) {
            this.$router.push({ name: 'jobaction', params: { action: '7' } })
          }
        }
      }
    },
    isJobActionCopleted (jobActionType) {
      let completedJobActions = this.$store.state.completedJobActions
      return completedJobActions.find(jobAction => jobAction.jobActionType === jobActionType && jobAction.standId === this.currentStandId && jobAction.jobId === this.activeJob.id)
    },
    isJobActionSkipped (standId, jobID) {
      let stands = this.$store.state.stands
      if (!stands) return false
      return stands.find(stand =>
        stand.standId === standId &&
        stand.jobId === jobID && stand.isSkipped
      ) || false
    }
  }
}
